module.exports = __webpack_public_path__ + "media/images/collection-1-6b8b239c9da13107e6a4bc4ef1c46c69.jpg";